import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { useParams, Link } from 'react-router-dom';
import api from '../services/api';

const PageView = () => {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPage();
  }, [slug]);

  const loadPage = async () => {
    try {
      const response = await api.get(`/pages/${slug}/`);
      setPage(response.data);
    } catch (error) {
      console.error('Error loading page:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Container className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </Container>
    );
  }

  if (!page) {
    return (
      <Container className="py-5">
        <h1>Page Not Found</h1>
        <Link to="/" className="btn btn-primary">Go Home</Link>
      </Container>
    );
  }

  return (
    <Container className="py-5">
      <h1 className="page-title">{page.title}</h1>
      <div className="page-content" dangerouslySetInnerHTML={{ __html: page.content }} />
    </Container>
  );
};

export default PageView;
